import styled from 'styled-components';

export const StyledBooksContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px;
  width: calc(100% - 200px);
`;
